export default class InstallmentPayments {
  constructor() {}
  installment0ney(buttonElt) {
    if (!buttonElt) {
      return;
    }
    buttonElt.addEventListener('click', () => {
      const dataSets = buttonElt.dataset;
      if (!dataSets.scripturl) {
        return;
      }
      try {
        const options = {
          country: dataSets.country,
          language: dataSets.language,
          merchant_guid: dataSets.merchantguid,
          payment_amount: dataSets.paymentamount,
          filter_by: dataSets.filterby,
          business_transaction_codes: dataSets.businesstransactioncodes.split(','),
          merchant_name: dataSets.merchantname,
          oney_bnpl_link: dataSets.bnpllink,
          exclusivity_type: dataSets.exclusivitytype,
          credit_intermediary_category: dataSets.creditintermediarycategory
        };
        if (window.oneyMerchantApp) {
          loadOneyPopin(options);
        } else {
          appendJsScript(dataSets.scripturl, () => {
            loadOneyPopin(options);
          });
        }
      } catch (error) {
        throw new Error(error);
      }
    });
  }
  installmentPaypal(buttonElt) {
    if (!buttonElt) {
      return;
    }
    this.loadScriptPaypal = false;
    buttonElt.addEventListener('click', () => {
      const dataSets = buttonElt.dataset;
      if (!dataSets.scripturl) {
        return;
      }
      try {
        if (!this.loadScriptPaypal) {
          appendJsScript(dataSets.scripturl, () => {
            this.modal = paypal.MessagesModal({
              buyerCountry: dataSets.buyerCountry,
              amount: dataSets.paymentamount,
              onReady: ({
                show,
                hide
              }) => {
                show();
              }
            });
            this.modal.render(buttonElt);
            this.loadScriptPaypal = true;
          });
        } else {
          this.modal.show();
        }
      } catch (error) {
        throw new Error(error);
      }
    });
  }
}
function loadOneyPopin(options) {
  loadOneyWidget(() => {
    oneyMerchantApp.loadSimulationPopin({
      options
    });
  });
}
function appendJsScript(url, callback) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.onload = callback;
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}